


export const getTokenPersonaLS = () => {
  const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario'));
  const tokenPersona = (detalleUsuario) ? detalleUsuario.persona.token : null;
  // console.log('tokenPersona', tokenPersona);
  return tokenPersona;
}


export const getUserNameLS = () => {
  const usuarioLS = JSON.parse(localStorage.getItem('usuario'));
  const username = (usuarioLS) ? usuarioLS.username : null;
  return username;
}


export const getEstablecimientoLS = () => {
  const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario'));
  const establecimiento = (detalleUsuario) ? detalleUsuario.establecimiento : null;
  return establecimiento;
}


export const getIdDoctorLS = () => {
  const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario'));
  let idDoctor = null
  try{idDoctor = (detalleUsuario) && detalleUsuario.persona.doctorSet && detalleUsuario.persona.doctorSet.length ? detalleUsuario.persona.doctorSet[0].id : null;}catch(error){console.log("error", error)}
  
  return idDoctor;
}


export const getPermisosLS = () => {
  const permisos = JSON.parse(localStorage.getItem('permisos'));
  return permisos || null;
}

export const getDataDoctor = () => {
  const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario'));
  const doctor = (detalleUsuario) && detalleUsuario.persona.doctorSet.length ? detalleUsuario.persona.doctorSet[0]: null;
  
  return doctor
}

export const getInfoDoc = () => {
  const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario'));
  const doctor = (detalleUsuario) && detalleUsuario.persona.doctorSet.length ? detalleUsuario.persona.doctorSet[0]: null;
  if(doctor){
    return detalleUsuario.persona
  }
  return doctor
}